import { rd } from '@passionware/monads';
import { FeatureService } from 'v5/services/front/FeatureService/FeatureService';

export function useManageEnterpriseFeature(
  featureService: FeatureService
): boolean {
  return rd.getOrElse(featureService.useFeature('manage-enterprise'), false);
}
